<template>
	<div>
		<modal-confirmacao
			:exibir="exibir"
			:mensagem="getMensagemModalConfirmacaoEfetivacao()"
			:subtituloModal="subtituloModalEnvioPncp"
			:tituloModal="tituloModalEnvioPncp"
			@confirmar="enviarPncp"
			@fechar-modal="$emit('fechar-modal')"
		></modal-confirmacao>
	</div>
</template>
<script>
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import { actionTypes } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'
import mutationTypes from '@/core/constants/mutation-types'

export default {
	name: 'modal-enviar-ata-pncp',
	components: { ModalConfirmacao },
	mixins: [validacaoAta],
	props: {
		exibir: Boolean,
	},
	data() {
		return {
			subtituloModalEnvioPncp: 'Deseja realmente enviar?',
			tituloModalEnvioPncp: 'Enviar PNCP',
		}
	},
	methods: {
		async enviarPncp() {
			await this.$store.dispatch(actionTypes.ATA.ENVIAR_ATA_PARA_PNCP, this.$route.params.id)
			await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, this.$route.params.id)
			await this.fecharAposConfirmacao()
			this.$store.commit(mutationTypes.ATA.DOCUMENTOS_ATA.ATUALIZAR_LISTAGEM)
		},
		getMensagemModalConfirmacaoEfetivacao() {
			if (this.possuiDocumentoTipoAtaRegistroPrecoNaoAssinado) {
				return 'Atenção! O documento da Ata está sem assinatura e será enviado ao PNCP. Essa é uma ação permanente!'
			}

			return ''
		},
		async fecharAposConfirmacao() {
			this.mostrarNotificacaoSucessoDefault()
			this.fecharModal()
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>
<style lang="stylus" scoped></style>
